import React from "react";
import {
  Box,
  Typography,
  Container,
  List,
  ListItem,
  ListItemText,
  Card,
  CardContent,
  Divider,
} from "@mui/material";
import { Helmet } from "react-helmet"; // Importing react-helmet
import { useTheme } from "@mui/material/styles";

const GetInvolved = () => {
  const theme = useTheme();

  const opportunities = [
    "Volunteer for Church Programs, including outreach and community services",
    "Participate in Church Events, such as festivals, retreats, and special gatherings",
    "Support with Donations to fund church operations and initiatives",
    "Join Bible Study Groups to deepen your spiritual understanding and fellowship",
    "Contribute to Our New Church Construction to help build a better place of worship",
    "Support Our Daily Church Activities Needs",
  ];
  

 const trustDetails = {
    name: "Praise Revival Church",
    accountNumber: "6495817377",
    bank: "Indian Bank",
    branch: "Vennampatti,Dharmapuri",
    ifsc: "IDIB000V129",
  };

  return (
    <Box
      sx={{
        py: 5,
        backgroundColor: "background.default",
        animation: `${theme.keyframes.fadeIn} 1.5s`,
      }}
    >
      {/* SEO Metadata */}
      <Helmet>
        <title>Get Involved | Praise Revival Church Dharmapuri</title>
      </Helmet>

      <Container>
        {/* Page Title */}
        <Typography
          variant="h2"
          gutterBottom
          align="center"
          sx={{
            fontWeight: "bold",
            color: "primary.main",
            animation: `${theme.keyframes.fadeInUp} 1.5s`,
          }}
        >
          Get Involved
        </Typography>
        <Typography
          variant="body1"
          paragraph
          align="center"
          sx={{
            mb: 4,
            fontSize: "1.2rem",
            color: "text.secondary",
            animation: `${theme.keyframes.fadeInUp} 2s`,
          }}
        >
          Join our efforts to make a difference in the church and the community.
        </Typography>

        {/* List of Opportunities */}
        <Box sx={{ mb: 6 }}>
          <Typography
            variant="h4"
            gutterBottom
            sx={{
              color: "primary.main",
              animation: `${theme.keyframes.fadeInUp} 2.5s`,
              textAlign: "center",
            }}
          >
            How You Can Get Involved
          </Typography>
          <List>
            {opportunities.map((opportunity, index) => (
              <ListItem
                key={index}
                sx={{
                  animation: `${theme.keyframes.fadeIn} 1.5s`,
                  borderBottom: `1px solid ${theme.palette.divider}`,
                }}
              >
                <ListItemText
                  primary={opportunity}
                  primaryTypographyProps={{
                    variant: "h6",
                    sx: { color: "text.primary", fontWeight: 500 },
                  }}
                />
              </ListItem>
            ))}
          </List>
        </Box>

        {/* Donation Card */}
        <Box sx={{ textAlign: "center" }}>
          <Card
            elevation={3}
            sx={{
              maxWidth: "600px",
              mx: "auto",
              borderRadius: 2,
              overflow: "hidden",
              boxShadow: theme.shadows[3],
              animation: `${theme.keyframes.zoomIn} 1.5s`,
            }}
          >
            <CardContent sx={{ backgroundColor: "background.paper", p: 4 }}>
              <Typography
                variant="h5"
                sx={{
                  fontWeight: "bold",
                  color: "secondary.main",
                  textAlign: "center",
                }}
              >
                Support Us with Your Donations
              </Typography>
              <Divider sx={{ my: 2 }} />
              <Typography
                variant="body1"
                sx={{
                  color: "text.primary",
                  mb: 2,
                  textAlign: "center",
                }}
              >
                Your contributions help us expand our programs and serve the community better.
              </Typography>
              <Typography
                variant="body1"
                sx={{ fontWeight: "bold", color: "primary.main" }}
              >
                Name: {trustDetails.name}
              </Typography>
              <Typography variant="body2" sx={{ mt: 1, color: "text.secondary" }}>
                Account Number: {trustDetails.accountNumber}
              </Typography>
              <Typography variant="body2" sx={{ mt: 1, color: "text.secondary" }}>
                Bank: {trustDetails.bank}
              </Typography>
              <Typography variant="body2" sx={{ mt: 1, color: "text.secondary" }}>
                Branch: {trustDetails.branch}
              </Typography>
              <Typography variant="body2" sx={{ mt: 1, color: "text.secondary" }}>
                IFSC: {trustDetails.ifsc}
              </Typography>
              <Typography
                variant="body1"
                sx={{ fontWeight: "bold", color: "primary.main" }}
              >
                Gpay/PhonePe : +91 94428-25800
              </Typography>
            </CardContent>
          </Card>
        </Box>
      </Container>
    </Box>
  );
};

export default GetInvolved;
